// extracted by mini-css-extract-plugin
export default {"legalTextBanner":"legaltext-banner_legalTextBanner__XNmrQ","legalTextContent":"legaltext-banner_legalTextContent__FLZYK"};